// @flow

const UNAUTHORIZED = 401;
const NOT_FOUND = 404;
const EXPECTATION_FAILED = 417;
const UNPROCESSABLE_ENTITY = 422;
const INTERNAL_SERVER_ERROR = 500;
const SERVICE_UNAVAILABLE = 503;

export {
  UNAUTHORIZED,
  NOT_FOUND,
  EXPECTATION_FAILED,
  UNPROCESSABLE_ENTITY,
  INTERNAL_SERVER_ERROR,
  SERVICE_UNAVAILABLE,
};
